import {
	Button,
	ColourStateSolid,
	ToggleSwitch,
	ToggleType,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { faRectangleHistory } from '@fortawesome/pro-solid-svg-icons/faRectangleHistory';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink';
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy';
import { faWavePulse } from '@fortawesome/pro-solid-svg-icons/faWavePulse';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import React from 'react';

type EditSendsPageActionsType = {
	isActive: boolean;
	handleShowHistoryCallback: () => void;
	handleOpenCallback: () => void;
	handleCopyUrlCallback: () => void;
	handleTemplateStatusCallback: () => void;
	handleShowDeleteConfirmationCallback: () => void;
};

function EditSendsPageActions(props: EditSendsPageActionsType) {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium, isLarge } = useLayout();

	return (
		<div className='flex-row flex-gap-sm ml-a' style={{ width: 'auto' }}>
			<Button
				onClick={(e) => [e.preventDefault(), props.handleShowHistoryCallback()]}
				colour={ColourStateSolid.Secondary}
				title={t('actions.history')}
				iconOnly={isTiny || isSmall || isMedium || isLarge}
				icon={faRectangleHistory}
				squared
			/>
			<Button
				onClick={(e) => [e.preventDefault(), props.handleOpenCallback()]}
				colour={ColourStateSolid.Secondary}
				title={t('actions.open')}
				iconOnly={isTiny || isSmall || isMedium || isLarge}
				icon={faExternalLink}
				squared
			/>
			<Button
				onClick={(e) => [e.preventDefault(), props.handleCopyUrlCallback()]}
				colour={ColourStateSolid.Secondary}
				title={t('actions.copyUrl')}
				iconOnly={isTiny || isSmall || isMedium || isLarge}
				icon={faCopy}
				squared
			/>

			<Button
				onClick={(e) => [e.preventDefault(), props.handleTemplateStatusCallback()]}
				colour={ColourStateSolid.Secondary}
				title={t('status.active')}
				iconOnly={isTiny || isSmall || isMedium || isLarge}
				icon={faWavePulse}
				squared
				addon={
					<ToggleSwitch
						extraClass='ml-md'
						hideLabel
						type={ToggleType.Switch}
						label={props.isActive ? t('actions.disable') : t('actions.makeActive')}
						name='pageActive'
						defaultChecked={props.isActive}
					/>
				}
			/>

			<Button
				onClick={(e) => [e.preventDefault(), props.handleShowDeleteConfirmationCallback()]}
				colour={ColourStateSolid.Alert}
				title={t('actions.delete')}
				iconOnly={isTiny || isSmall || isMedium || isLarge}
				icon={faTrash}
				squared
			/>
		</div>
	);
}

export { EditSendsPageActions };
